import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-cost-item',
  templateUrl: './cost-item.component.html',
  styleUrl: './cost-item.component.scss'
})
export class CostItemComponent {
  @Input() cost: string = '';
  @Input() yearCost: string = '';
  @Input() hasSubTitle: boolean = false;
  @Input() hasPerMonth: boolean = false;
  @Input() isOfferApplicable: boolean = false;
  @Input() showPerMonth: boolean = false;
  @Input() numberOfInstallments: number = 0;
}
